import axios from "axios";
import router from "../router/index"
import { Toast, Dialog } from 'vant';

const api = axios.create({
  baseURL: process.env.SERVER, // 所有请求的公共地址部分
  timeout: 10000 // 请求超时时间
})

// interceptors axios的拦截器对象
api.interceptors.request.use(config => {
  const userInfo = JSON.parse(localStorage.getItem('sele_user_info')) || {}
  config.headers['accessToken'] = userInfo.token
  config.headers['account'] = userInfo.account
  config.headers['source'] = 'mobile'
  // config 请求的所有信息
  // 响应成功的返回
  return config // 将配置完成的config对象返回出去 如果不返回 请求讲不会进行
}, err => {
  // 请求发生错误时的相关处理 抛出错误
  //  //响应失败的返回
  Promise.reject(err)
})


//响应拦截处理  响应拦截器：包含两个函数（一个是成功返回的函数，一个是失败的返回的函数）
api.interceptors.response.use(res => {
  // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
  // res 是所有相应的信息
  return { data: res.data, url: res.config.url }
  // return res.data
}, err => {
  // 服务器响应发生错误时的处理
  // if (err.response.status === 400) {
  //   Toast.fail({
  //     duration: 5000,
  //     message: '系统错误',
  //     closeOnClick: true
  //   })
  //   return
  // }
  Promise.reject(err)
})

function get (url, params) {
  return http(url, params, 'get')
}

function post (url, params) {
  return http(url, params, 'post')
}
function http (url, params, type) {
  return new Promise(function (resolve, reject) {
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      closeOnClick: true
    });
    api[type](url, params).then(function (response) {
      toast.clear()
      if (typeof response.data === 'string') {
        resolve(response.data);
      } else if (response.data.code === '0000') {
        resolve(response.data);
      } else {
        subDialog(response).then(() => {
          if (response.data.code === '0015' || response.data.code === '0006') {
            // 跳转至登陆页
            let isSupplier = localStorage.getItem('is_supplier')
            if (isSupplier === '0') {
              window.location.href = `https://sso.hnair.net/login?appid=fitnet-crew&servise=${window.location.host}`
            } else {
              router.push('/login')
            }
            return
          }
          resolve(response);
        })
      }
    }).catch(function (error) {
      toast.clear()
      Toast.fail({
        duration: 3000,
        message: '系统错误',
        closeOnClick: true
      })
      reject(error);
    });
  });
}

// 处理接口错误提示
function subDialog (data) {
  let message = data.data.message
  if (data.data.code === '0015') {
    const userInfo = JSON.parse(localStorage.getItem('sele_user_info'))
    if (userInfo && userInfo.token) {
      message = '登陆失效，请重新登陆！'
    } else {
      message = '请先登陆！'
    }
  } else if (data.url.includes('login/new/v2')) {// 供应商登陆
    if (data.data.code === '0010') {
      message = '验证码错误'
    }
    if (data.data.code === '8002') {
      message = '用户名或密码错误！'
    }
  } else if (data.url.includes('login/new/mobile')) {// 机组人员tickey解析
    message = '登陆失效，请重新登陆！'
  }
  return new Promise((resolve, reject) => {
    Dialog.alert({
      title: '提示',
      message: message,
      messageAlign: 'left'
    }).then(() => {
      resolve(data);
    })
  })
}


//最后一步 暴露出去实例导出
export default { get, post }


// WEBPACK FOOTER //
// ./src/server/api.js